export const support_href = 'support@tubyx.com';
export const support_title = 'support@tubyx.com';
export const tubux_href = 'https://app.tubyx.com';
export const privacy_href = '';
